(() => {
  'use strict';

  if (window.__slouAnalyticsInstalled) return;

  const configElement = document.getElementById('SlouAnalyticsConfig');
  let config;
  try {
    config = JSON.parse(configElement?.textContent || '{}');
  } catch {
    return;
  }
  if (config.enabled !== true || config.designMode === true || window.Shopify?.designMode) return;
  window.__slouAnalyticsInstalled = true;

  const seenSections = new Set();
  let lastSelection = '';
  let privacyLoadRequested = false;
  const sources = new Set(['hero', 'benefits', 'proof', 'community', 'tutorial', 'care', 'product']);
  const packQuantities = { single: 1, duo: 2, trio: 3 };

  function requestPrivacyAPI() {
    if (window.Shopify?.customerPrivacy || privacyLoadRequested || typeof window.Shopify?.loadFeatures !== 'function') return;
    privacyLoadRequested = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    } catch {
      privacyLoadRequested = false;
    }
  }

  function analyticsAllowed() {
    requestPrivacyAPI();
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch {
      return false;
    }
  }

  function identifier(value) {
    const text = typeof value === 'number' && Number.isSafeInteger(value) ? String(value) : value;
    if (typeof text !== 'string') return '';
    if (/^[a-z0-9][a-z0-9_.-]{0,119}$/i.test(text)) return text;
    return text.match(/^gid:\/\/shopify\/Video\/(\d+)$/)?.[1] || '';
  }

  function publish(name, data) {
    if (!analyticsAllowed() || typeof window.Shopify?.analytics?.publish !== 'function') return false;
    try {
      const result = window.Shopify.analytics.publish(name, { schema_version: 1, ...data });
      if (result && typeof result.catch === 'function') result.catch(() => {});
      return true;
    } catch {
      return false;
    }
  }

  document.addEventListener('slou:selection:change', (event) => {
    if (!analyticsAllowed()) return;
    const detail = event.detail || {};
    if (detail.origin !== 'user') return;
    const quantity = Object.hasOwn(packQuantities, detail.packId) ? packQuantities[detail.packId] : 0;
    if (!quantity || detail.quantity !== quantity) return;
    if (![detail.blueCount, detail.pinkCount].every((count) => Number.isInteger(count) && count >= 0 && count <= 3)) return;
    if (detail.blueCount + detail.pinkCount !== quantity) return;
    const data = {
      pack_id: detail.packId,
      quantity,
      blue_count: detail.blueCount,
      pink_count: detail.pinkCount,
    };
    if (Number.isSafeInteger(detail.priceCents) && detail.priceCents >= 0 && /^[A-Z]{3}$/.test(detail.currency || '')) {
      data.price_cents = detail.priceCents;
      data.currency = detail.currency;
    }
    const key = JSON.stringify(data);
    if (key === lastSelection) return;
    if (publish('slou:pack_selected', data)) lastSelection = key;
  });

  document.addEventListener('slou:video:play', (event) => {
    const detail = event.detail || {};
    const videoId = identifier(detail.videoId);
    if (!videoId) return;
    publish('slou:video_played', {
      video_id: videoId,
      placement: sources.has(detail.source) ? detail.source : 'other',
    });
  });

  document.addEventListener('slou:shop:reached', (event) => {
    const sectionId = identifier(event.detail?.sectionId);
    if (!sectionId || seenSections.has(sectionId)) return;
    if (publish('slou:shop_reached', { section_id: sectionId })) seenSections.add(sectionId);
  });

  document.addEventListener('visitorConsentCollected', () => {
    if (!analyticsAllowed()) {
      seenSections.clear();
      lastSelection = '';
    }
  });

  requestPrivacyAPI();
})();
